// kits/DesignKit/underlineColors.js

const underlineColors = {
  yellow: "#facc15",   // Tailwind yellow-400
  blue:   "#60a5fa",   // Tailwind blue-400
  pink:   "#f472b6",   // Tailwind pink-400
  white:  "#fff",
  black:  "#000",
  gray:   "#d1d5db",   // Tailwind gray-300
  black_gray: "#a1a1a1",
  ZenBrand: "#AC8E66"
  // beliebig mehr!
};

export default underlineColors;
